import { TagColor as Color } from '@factorialco/deprecated-design-system'
import { PerformanceValueObjectsReviewProcessStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const getStatusMappings = (): Record<
  PerformanceValueObjectsReviewProcessStatusEnum,
  { color: Color; label: string }
> => ({
  ['draft']: {
    color: Color.champagne,
    label: i18n.t('performance_process.reviews.review_status.draft'),
  },
  ['scheduled']: {
    color: Color.malibu,
    label: i18n.t('performance_process.reviews.review_status.scheduled'),
  },
  ['starting']: {
    color: Color.champagne,
    label: i18n.t('performance_process.reviews.review_status.starting'),
  },
  ['active']: {
    color: Color.correct,
    label: i18n.t('performance_process.reviews.review_status.active'),
  },
  ['finished']: {
    color: Color.grey,
    label: i18n.t('performance_process.reviews.review_status.finished'),
  },
})

export const tagColor = (reviewStatus: PerformanceValueObjectsReviewProcessStatusEnum): Color => {
  const mapping = getStatusMappings()[reviewStatus]
  return mapping ? mapping.color : Color.grey
}

export const tagLabel = (reviewStatus: PerformanceValueObjectsReviewProcessStatusEnum) => {
  const mapping = getStatusMappings()[reviewStatus]
  return mapping ? mapping.label : i18n.t('performance_process.reviews.review_status.unknown')
}
